var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2034_31",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2034_31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 18.3333C8.84706 18.3333 7.76373 18.1146 6.74984 17.6771C5.73595 17.2396 4.854 16.6458 4.104 15.8958C3.354 15.1458 2.76025 14.2639 2.32275 13.25C1.88525 12.2361 1.6665 11.1528 1.6665 10C1.6665 8.84723 1.88525 7.76389 2.32275 6.75C2.76025 5.73612 3.354 4.85417 4.104 4.10417C4.854 3.35417 5.73595 2.76042 6.74984 2.32292C7.76373 1.88542 8.84706 1.66667 9.99984 1.66667C11.1526 1.66667 12.2359 1.88542 13.2498 2.32292C14.2637 2.76042 15.1457 3.35417 15.8957 4.10417C16.6457 4.85417 17.2394 5.73612 17.6769 6.75C18.1144 7.76389 18.3332 8.84723 18.3332 10C18.3332 11.1528 18.1144 12.2361 17.6769 13.25C17.2394 14.2639 16.6457 15.1458 15.8957 15.8958C15.1457 16.6458 14.2637 17.2396 13.2498 17.6771C12.2359 18.1146 11.1526 18.3333 9.99984 18.3333ZM5.27067 14.7292L9.99984 10V3.33334C8.13873 3.33334 6.56234 3.97917 5.27067 5.27084C3.979 6.56251 3.33317 8.13889 3.33317 10C3.33317 10.8889 3.49984 11.7431 3.83317 12.5625C4.1665 13.3819 4.64567 14.1042 5.27067 14.7292Z",
    fill: "#5C5C70"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockLoader);
export default __webpack_public_path__ + "static/media/clock-loader.37faf6b7ece1168fe52dff73c5c2e88b.svg";
export { ForwardRef as ReactComponent };